{
  "en": {
    "history": {
      "heading": {
        "title": "My History"
      },
      "empty": {
        "noHistory": "You have not enrolled in any courses yet. Discover our webinars and professional development courses and find out what's most relevant to you."
      },
      "links": {
        "allCourses": "Explore our entire catalog"
      },
      "group": {
        "heading": {
          "title": "Groups",
          "group": "Group",
          "access": "Access",
          "link": "Link",
          "actions": "Actions"
        },
        "links": {
          "goToGroup": "Go to group",
          "myMaterial": "My Material",
          "editMaterial": "Edit project work",
          "createMaterial": "Submit project work",
          "downloadCertificate": "Download certificate",
          "adminArea": "Admin area"
        }
      },
      "course": {
        "heading": {
          "title": "My Courses",
          "course": "Course",
          "access": "Access until",
          "certificate": "Certificate"
        },
        "links": {
          "downloadCertificate": "Download Certificate"
        },
        "infos": {
          "missingProcess": "To be completed:"
        }
      }
    }
  }
}
